import { Injectable } from '@angular/core';
import { FilterMapAPIService } from '../../shared/services/API/Filter-MapAPI.service';
@Injectable({
    providedIn: 'root'
  })

export class FilterMapService{
  constructor(
    private filterMapService: FilterMapAPIService){
  }

  getFiltersByModule(module : any){
    return this.filterMapService.getFiltersByModule(module);
  }

  getValuesByFilterModule(name : string, module : string) {
    return this.filterMapService.getValuesByFilterModule(name, module);
  }

  getValuesByFilterColumn(column : string, module : string) {
    return this.filterMapService.getValuesByFilterColumn(column, module);
  }
}
